var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _rect, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWord64X = function SvgWord64X(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Word_64x_svg__a",
    x1: 5.56,
    x2: 26.441,
    y1: 13.917,
    y2: 50.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2368c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1a5dbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1146ac"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#41a5ee",
    d: "M60.333 4H17.667A2.667 2.667 0 0 0 15 6.667V18l24 5.421L63 18V6.667A2.667 2.667 0 0 0 60.333 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b7cd3",
    d: "M63 18H15v14l24 5.442L63 32z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#185abd",
    d: "M15 32v14l24 6.347L63 46V32z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#103f91",
    d: "M17.667 60h42.666A2.667 2.667 0 0 0 63 57.333V46H15v11.333A2.667 2.667 0 0 0 17.667 60"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h64v64H0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33 18.631v29.738a2 2 0 0 1-.045.452A2.606 2.606 0 0 1 30.378 51H15V16h15.378A2.62 2.62 0 0 1 33 18.631",
    opacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34 18.76v27.48a3.73 3.73 0 0 1-1.163 2.71A3.68 3.68 0 0 1 30.278 50H15V15h15.278A3.755 3.755 0 0 1 34 18.76",
    opacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33 18.652v27.7A2.63 2.63 0 0 1 30.378 49H15V16h15.378A2.63 2.63 0 0 1 33 18.652",
    opacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32 18.652v27.7A2.64 2.64 0 0 1 29.359 49H15V16h14.359A2.64 2.64 0 0 1 32 18.652",
    opacity: 0.1
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h64v64H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    y: 16,
    fill: "url(#Word_64x_svg__a)",
    rx: 2.667
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.942 36.448q.078.617.1 1.076h.061q.036-.435.139-1.052t.2-1.039l2.805-12.1h3.626l2.9 11.919a17 17 0 0 1 .362 2.248h.049a17 17 0 0 1 .3-2.176l2.321-11.991h3.3l-4.058 17.334h-3.856l-2.768-11.483q-.12-.5-.272-1.294t-.187-1.16h-.048q-.05.423-.188 1.257t-.223 1.233l-2.6 11.447H8.99l-4.1-17.334h3.36l2.526 12.124q.087.375.166.991"
  })));
};
export default SvgWord64X;